import { useEffect } from 'react';

import { PRISMIC_REF_REFETCH_INTERVAL, loadMasterRef } from '@/services/prismicService.ts';

const usePrismicRef = (): void => {
    useEffect(() => {
        void loadMasterRef();

        // Set up interval to refresh master ref every 5 minutes
        const interval_id = setInterval(() => {
            void loadMasterRef();
        }, PRISMIC_REF_REFETCH_INTERVAL);

        // Clean up interval on component unmount
        return (): void => clearInterval(interval_id);
    }, []);
};

export default usePrismicRef;
